import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api, { formatApiErrorDetail } from "@/lib/api";
import Seo from "@/components/Seo";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Seo title="Forgot Password" path="/forgot-password" />
      <div className="flex min-h-screen items-center justify-center bg-[#133827] px-4">
        <div className="w-full max-w-md rounded-3xl bg-white p-8 shadow-2xl sm:p-10">
          <h1 className="font-display text-2xl font-bold text-[#18201B]">Reset your password</h1>
          {sent ? (
            <p className="mt-4 text-sm text-[#526057]" data-testid="forgot-confirmation">
              If that email is registered, a reset link has been sent. Please check your inbox.
            </p>
          ) : (
            <form onSubmit={submit} className="mt-6 space-y-4" data-testid="forgot-form">
              <p className="text-sm text-[#526057]">Enter your account email and we'll send you a reset link.</p>
              <div>
                <Label htmlFor="email">Email</Label>
                <Input id="email" type="email" required data-testid="forgot-email-input" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5" />
              </div>
              {error && <p className="text-sm text-destructive">{error}</p>}
              <Button type="submit" disabled={loading} data-testid="forgot-submit-btn" className="w-full bg-[#133827] text-white hover:bg-[#0d261a]">
                {loading ? "Sending…" : "Send Reset Link"}
              </Button>
            </form>
          )}
          <Link to="/admin/login" className="mt-4 inline-block text-sm text-[#2C5E43] hover:underline" data-testid="forgot-back-link">← Back to sign in</Link>
        </div>
      </div>
    </>
  );
}
